// Default settings
const configs = {
    api_url: process.env.API_URL || 'http://127.0.0.1:8000',
    ketv_url: process.env.KETV_URL || null,
    env: process.env.NODE_ENV || 'development',
    is_prod: process.env.NODE_ENV === 'production' || false,
};

export function getConfig(key) {
    return configs[key];
}
